<div class="header-right-side-container" [ngClass]="{ 'public-link': publicReviewLink || publicPage }">
  <!-- <top-nav-voting [shouldDisableInteractiveElements]="shouldDisableInteractiveElements"></top-nav-voting> -->
  <!-- <top-nav-compare-btn></top-nav-compare-btn> -->
  <ng-container *ngIf="(isSubsectionPage || isMySpacePage) && showListViewToggleButton">
    <div class="d-flex align-items-center buttons me-2">
      <button
        class="d-flex align-items-center justify-content-center flex-grow-1 btn btn-list-view py-2 px-1"
        [class.my-space-list-view]="isMySpacePage"
        title="Toggle ListView"
        (click)="toggleListView()"
        [class.active]="isListViewMode"
        [class.inactive]="!isListViewMode">
        <span class="icon-wrapper">
          <!-- A.MAK: we can change with this fontAwesome icons -->
          <img
            src="assets/svg/subsection/toggle-list-view-icon.svg"
            width="18"
            height="18"
            alt="Toggle ListView"
            loading="lazy" />
        </span>
      </button>
    </div>
  </ng-container>

  <mtm-top-nav-drive-share-btn />
  <mtm-top-nav-drive-compare-btn />
  <top-nav-treeview-btn></top-nav-treeview-btn>

  <!-- Drive surfaces carry Tasks on their right rail (beside the feed), not up here;
       My Own Space and compare have no tasks at all. -->
  @if (
    (isPlatformTaskShowing || isMediaPreviewTasksChatShowing) &&
    hasCommentPanelWidth &&
    !driveRightRail.visible() &&
    !isMySpacePage
  ) {
    <button
      class="d-none d-md-flex align-items-center justify-content-center flex-grow-1 btn chat-button py-2 px-1 me-1"
      title="Task"
      (click)="openTask()"
      [disabled]="false"
      [attr.aria-disabled]="false"
      [class.active]="isTaskExpanded && rightViewMode === 'task'"
      [class.inactive]="!isTaskExpanded">
      <span class="icon-wrapper">
        <mtm-task-icon
          width="18"
          height="18"
          class="clickable"
          [active]="isTaskExpanded && rightViewMode === 'task'"></mtm-task-icon>
      </span>
    </button>
  }

  <!-- Drive surfaces carry no top-nav comment button (STUDIO-2249): the drive
       explorer owns the comment/feed panel and exposes its own in-content
       toolbar toggle, so a second entry point up here was redundant. `cm` deep
       links still open the panel — see `commentToggleState`. -->
  @if (
    !showDriveSurface &&
    !isMySpacePage &&
    !isOrgDriveCommentsActive &&
    (isPlatformCommentsChatShowing || isMediaPreviewCommentsChatShowing) &&
    hasCommentPanelWidth
  ) {
    <button
      class="d-none d-md-flex align-items-center justify-content-center flex-grow-1 btn chat-button py-2 px-1"
      title="Comment"
      (click)="openChat()"
      [disabled]="isCommentUiInitializing"
      [attr.aria-disabled]="isCommentUiInitializing"
      [class.active]="isCommentExpanded && rightViewMode === 'comment'"
      [class.inactive]="!isCommentExpanded">
      <span class="icon-wrapper">
        <mtm-chat-sparkle-icon width="18" height="18" class="clickable"></mtm-chat-sparkle-icon>
      </span>
    </button>
  }

  <!-- <top-nav-fullscreen-btn></top-nav-fullscreen-btn> -->

  <!-- On drive surfaces the bell is on the right rail (child-layout). -->
  <selector-notification-dropdown
    *ngIf="!publicReviewLink && !publicPage && authUser && !driveRightRail.visible()">
  </selector-notification-dropdown>

  @if (onBehalf()) {
    <button
      class="btn language-button logout-on-behalf logout-on-behalf--inverse"
      [style.white-space]="'nowrap'"
      (click)="backToAdmin()">
      Logout on behalf
    </button>
  }
</div>
